import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { environmentProvider } from '@shared/environment-provider';

@Component({
  selector: 'onboarding-login-redirect',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class OnboardingLoginRedirectComponent implements OnInit {
  ngOnInit() {
    window.location.href = this.getOnboardingSiteLoginUrl();
  }

  private getOnboardingSiteLoginUrl() {
    const { onboardingSiteUrl, onboardingSite } =
      environmentProvider.getEnvironment();
    const { trimbleIdentityApiBaseUrl } =
      environmentProvider.getServiceApiBaseUrls();

    const tidBaseUrl = `${trimbleIdentityApiBaseUrl}/oauth/authorize?response_type=code&scope=openid+${onboardingSite.tid.appName}&client_id=${onboardingSite.tid.clientId}`;

    const redirectUrl = `${tidBaseUrl}&redirect_uri=${onboardingSiteUrl}/auth/redirect&prompt=none`;

    return redirectUrl;
  }
}
